import { IPublishOption } from '../../../../../redux/reducers';

export const isCalltrackingPaid = (periods: Array<IPublishOption>): boolean => {
  return periods.some(({ isPaid }) => isPaid);
};
